import { createArtifactApi } from "@org-avp/avp-avengers-artifact-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: environment.NX_ARTIFACT_SERVICE_BASE_URL,
  prepareHeaders,
};

export const artifactApi = createArtifactApi({
  baseQueryArgs,
});
